import { useQuery } from "react-query";
import { useAuth0 } from "@auth0/auth0-react";
import axios from "axios";
import { useStateIfMounted } from "use-state-if-mounted";
import useFetchData from "../../../../hooks/useFetchData";
import { DEFAULT_WATER_QUALITY_PARAMETERS_INFO_STATE } from "./WaterQualityParametersConstants";

export const useBasicWaterQualityParametersInfo = (
  selectedWaterQualityParameter
) => {
  const { getAccessTokenSilently } = useAuth0();

  const [editorState, setEditorState] = useStateIfMounted(
    DEFAULT_WATER_QUALITY_PARAMETERS_INFO_STATE
  );
  const [isDirty, setIsDirty] = useStateIfMounted(false);

  const handleUpdateState = (name, value) => {
    if (!isDirty) setIsDirty(true);
    setEditorState((prevState) => {
      let newFilterValues = { ...prevState };
      newFilterValues[name] = value;
      return newFilterValues;
    });
  };

  const handleResetState = () => {
    setIsDirty(false);
    if (selectedWaterQualityParameter) {
      setEditorState(data);
    } else {
      setEditorState(DEFAULT_WATER_QUALITY_PARAMETERS_INFO_STATE);
    }
  };

  const { data, isFetching, error, refetch } = useQuery(
    ["list-aqsci-parameters-with-akas", selectedWaterQualityParameter],
    async () => {
      if (!selectedWaterQualityParameter) {
        setIsDirty(false);
        setEditorState(DEFAULT_WATER_QUALITY_PARAMETERS_INFO_STATE);
        return {};
      }
      try {
        const token = await getAccessTokenSilently();
        const headers = { Authorization: `Bearer ${token}` };

        const { data } = await axios.get(
          `${process.env.REACT_APP_ENDPOINT}/api/list-aqsci-parameters-with-akas/${selectedWaterQualityParameter}`,
          { headers }
        );
        setIsDirty(false);
        setEditorState(data);
        return data;
      } catch (err) {
        console.error(err);
      }
    },
    {
      cacheTime: 0,
      keepPreviousData: false,
      refetchOnWindowFocus: false,
    }
  );

  const [UnitsLookup] = useFetchData("list-aqsci-units", [], true);

  return {
    data,
    isLoading: isFetching,
    error,
    refetch,
    isDirty,
    lookups: {
      Units: UnitsLookup,
    },
    handleUpdateState,
    handleResetState,
    state: editorState,
    setter: setEditorState,
  };
};
